var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowUpper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.001,
    height: 16.764,
    viewBox: "0 0 18.001 16.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_13288",
    "data-name": "\\uC0AC\\uAC01\\uD615 13288",
    width: 16.18,
    height: 14.763,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40289",
    "data-name": "\\uADF8\\uB8F9 40289",
    transform: "translate(-740.999 -754.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_20",
    "data-name": "\\uD569\\uCE58\\uAE30 20",
    d: "M13782-25400v-2h1l7.1-14.213a1,1,0,0,1,1.786,0L13799-25402h1v2Z",
    transform: "translate(-13041 26171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40288",
    "data-name": "\\uADF8\\uB8F9 40288",
    transform: "translate(741.91 754.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40287",
    "data-name": "\\uADF8\\uB8F9 40287",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_72339",
    "data-name": "\\uD328\\uC2A4 72339",
    d: "M1.118,14.763,7.954,1.079A.142.142,0,0,1,8.083,1a.146.146,0,0,1,.068.017.136.136,0,0,1,.06.061l6.85,13.685H16.18L9.106.63A1.146,1.146,0,0,0,7.06.63L0,14.763H1.118Z",
    fill: "current"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpper);
export default __webpack_public_path__ + "static/media/ic_arrow_upper.a7ca4e848c85e3dea9aeed3ceabeaa54.svg";
export { ForwardRef as ReactComponent };